import { defineVeeValidateGlobalRule } from "@/validator/global-rule"

export default () => {
    defineVeeValidateGlobalRule();
}